// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__1PtCm"};